import { gql } from "@apollo/client";

export default gql`
  query workerEmailTaken($email: String!) {
    workerEmailTaken(email: $email)
  }
`;
